import { MarketingLink } from "../MarketingButton";
import { LABELS_PATH } from "../products";

export default function LabelsCallout() {
  return (
    <section className="bg-[#F3F5FF] px-[6vw] py-[74px] max-[680px]:px-5 max-[680px]:py-[58px]">
      <div className="mx-auto flex w-[min(1180px,100%)] items-center justify-between gap-[42px] rounded-[25px] border border-[#DCE1F3] bg-white px-[42px] py-[38px] shadow-[0_18px_55px_rgba(16,28,84,0.08)] max-[680px]:flex-col max-[680px]:items-start max-[680px]:gap-[26px] max-[680px]:px-[26px] max-[680px]:py-[30px]">
        <div>
          <p className="mb-[10px] font-open-sans text-[14px] font-black uppercase tracking-[0.12em] text-blue-600">
            For labels
          </p>
          <h2 className="m-0 font-figtree text-[clamp(32px,4vw,50px)] font-black uppercase leading-none tracking-[-0.045em] text-marketing-ink">
            Managing multiple artists?
          </h2>
          <p className="mt-[13px] font-open-sans text-[17px] leading-[1.55] text-marketing-muted">
            Bring every catalog, release, and sale into one workspace built for
            your roster.
          </p>
        </div>
        <MarketingLink
          to={LABELS_PATH}
          className="shrink-0 rounded-full border-[1.5px] border-blue-600 px-5 py-[14px] font-open-sans text-[16px] font-black text-blue-600 max-[680px]:w-full max-[680px]:text-center"
        >
          Explore Lutely for Labels →
        </MarketingLink>
      </div>
    </section>
  );
}
